import cn from 'classnames';
import React from 'react';
import { WrapperProps } from 'src/entrypoints/root/wrapper';
import Markdown from '../../../../components/Markdown';
import { inIframe } from '../../../../utils/location';
import { useControlsProps } from '../../../../utils/questionPropsHelper';
import { ContentWrapper } from '../ContentWrapper';
import { Footer } from '../Footer';
import { Header } from '../Header';
import { RootWrapper } from '../RootWrapper';
import styles from './GroupWrapper.module.css';

interface GroupWrapperProps extends WrapperProps {
  group: { text?: string };
}

export const GroupWrapper = ({
  title,
  children,
  group,
  isWebview,
  hasWelcome,
  onBack,
  onClose,
  progress,
  progressBar,
  showBackButton,
  alignSurvey,
  ...props
}: GroupWrapperProps) => {
  const controlProps = useControlsProps(props);

  return (
    <div className={cn(styles.container, { [c(styles.iframe)]: inIframe() })}>
      <RootWrapper className={styles.container}>
        <Header
          className={styles.header}
          title={title}
          hasWelcome={hasWelcome}
          isWebview={isWebview}
          onBack={onBack}
          onClose={onClose}
          showBackButton={showBackButton}
          alignSurvey={alignSurvey}
          progress={{ ...progress, type: progressBar }}
        />

        {group.text && (
          <ContentWrapper borders="top">
            <Markdown
              className={cn(styles.title, {
                [c(styles.withSpacing)]: inIframe(),
                [c(styles.centerTitle)]: alignSurvey === 'center',
              })}
            >
              {group.text}
            </Markdown>
          </ContentWrapper>
        )}

        {children}

        <Footer className={styles.footer} alignSurvey={alignSurvey} {...controlProps} />
      </RootWrapper>
    </div>
  );
};
